import { translate, ipCountryQuery } from '@gig/magic-common';
import { __awaiter, __generator } from 'tslib';
import { required } from '@gig/magic-form-builder';
import { getCountries } from '../utils/countries.js';

function country(isLockedCountry) {
    var _this = this;
    return {
        id: 'country-wrapper',
        serverId: 'addrCountryCode',
        component: 'magic-ui-form-field',
        isDataField: false,
        validationBase: 'country',
        testId: 'step2-country',
        children: [
            {
                id: 'country',
                serverId: 'addrCountryCode',
                component: 'magic-ui-dropdown',
                isDataField: true,
                properties: {
                    // NOTE: we seem to have a race condition issue when
                    // multiple triggers are called after country change
                    // causing the component to be out of sync with the store
                    // and the component value reverts to the default country
                    'keep-alive': true,
                    'placeholder': translate('sign-up-step-two.country.placeholder'),
                    'disabled': isLockedCountry,
                },
                validation: [
                    {
                        name: 'required',
                        fn: required,
                    },
                ],
                preloadProperties: function () { return __awaiter(_this, void 0, void 0, function () {
                    var countries, currentIPCountry;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, getCountries()];
                            case 1:
                                countries = _a.sent();
                                return [4 /*yield*/, ipCountryQuery()];
                            case 2:
                                currentIPCountry = _a.sent();
                                return [2 /*return*/, {
                                        options: countries.countries.map(function (_a) {
                                            var name = _a.name, code = _a.code;
                                            return ({
                                                name: name,
                                                value: code,
                                            });
                                        }),
                                        value: currentIPCountry,
                                    }];
                        }
                    });
                }); },
            },
        ],
    };
}

export { country };
